import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import { authRoles } from 'app/auth';

import BillingAndReportsLayout from './layouts/BillingAndReportsLayout';

const ReportsTab = lazy(() => import('./use-cases/reports-list'));
const BillingTab = lazy(() => import('./use-cases/billing'));

const BillingAndReportsConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            organisationSelector: true,
          },
        },
      },
    },
  },
  auth: authRoles.pharmacyAdmin,
  routes: [
    {
      path: 'documents',
      element: <BillingAndReportsLayout />,
      children: [
        { path: '', element: <Navigate to="reports" replace /> },
        { path: 'reports', element: <ReportsTab /> },
        { path: 'billing', element: <BillingTab /> },
      ],
    },
  ],
};

export default BillingAndReportsConfig;
